import React from 'react'
import Footer from '../components/footer';
import Header from '../components/header';
import Contact from '../components/contact';


const ContactPage = () => {
  return (
    <div>
      {<Header/>}
      {<Contact/>}
      {<Footer/>}
    </div>
  )
}

export default ContactPage
